import modal from './modal';

var modalsObserver = {
    settings: {
        title: '',
        content: '',
        type: '',
        id: '',
        domNode: document.body,
        buttons: [],
        showFooter: true,
        scrollableContendNode: '.modal__content'
    },

    eventParams: {},
	
    notify( eventName , paramsToNotify = { }) {

        this.eventParams = {
            ...this.settings,
            ...paramsToNotify
        };

        const event = new CustomEvent( eventName , { detail: this.eventParams } );
        document.dispatchEvent(event);
        console.log(eventName);

    },

    setListeners() {

        document.addEventListener('modalsObserver::initNewModal', this.initNewModal , false);
    },
	
    initNewModal(e) {

        this.eventParams = {
            ...this.settings,
            ...e.detail
        };
			
        let initializatedModal = modal({
            title: this.eventParams.title,
            content: this.eventParams.content,
            type: this.eventParams.type,
            id: this.eventParams.id,
            buttons: this.eventParams.buttons,
            domNode: this.eventParams.domNode,
            showFooter: this.eventParams.showFooter,
            scrollableContendNode: this.eventParams.scrollableContendNode
        });

        const newModal = new initializatedModal();
        newModal.open();
    },

    init() {

        this.initNewModal = this.initNewModal.bind(this);
        this.setListeners();
        this.notify('modalsObserver::ready');
    }
};

export default modalsObserver;


// WEBPACK FOOTER //
// ./cpanel/js/components/modals/modules/modalsObserver-functions.js